import React from 'react';
import { StyledHeader } from '../styled';
import { Link, Flexer } from '@ontruck/orc';
import ToggleHiddenLogs from './ToggleHiddenLogs';

import { ReactComponent as CheckIcon } from 'assets/icons/girded-check.svg';
import { ReactComponent as AddIcon } from 'assets/icons/add.svg';
import { injectIntl } from 'react-intl';

const ListHeader = ({
  totalLogs,
  journeyId,
  showAddLog,
  onCreateLogClick,
  onCreateJourneyLogClick,
  handleOpenManualTask,
  hideSomeLogs,
  setHideSomeLogs,
  intl,
}) => {
  const t = intl.messages.modules.logs;
  return (
    <StyledHeader data-testid="LogsListHeader">
      <StyledHeader.Title>
        <strong>
          {t.logs_title}({totalLogs})
        </strong>
        <ToggleHiddenLogs hideSomeLogs={hideSomeLogs} setHideSomeLogs={setHideSomeLogs} />
      </StyledHeader.Title>
      <StyledHeader.Links>
        {journeyId && (
          <Flexer.Parent alignItems="center" data-testid="add-task">
            <CheckIcon />
            <Link text={t.add_task} noWrap weight="bold" onClick={handleOpenManualTask} />
          </Flexer.Parent>
        )}
        {showAddLog && (
          <Flexer.Parent alignItems="center" mLeft="S" data-testid="add-log">
            <AddIcon />
            <Link
              onClick={onCreateLogClick ? onCreateLogClick : onCreateJourneyLogClick}
              text={t.add_log}
              noWrap
              weight="bold"
            ></Link>
          </Flexer.Parent>
        )}
      </StyledHeader.Links>
    </StyledHeader>
  );
};

export default injectIntl(ListHeader);
